/**
 * Entity ID normalization — single source of truth (frontend).
 *
 * Canonical pair:
 *   - coord-frontend/src/utils/entityId.js       (this file)
 *   - coord-backend/src/lib/entityId.js          (must match byte-for-byte)
 *
 * Any change here MUST be mirrored in the backend twin. Divergence will
 * cause manually-added family members and chat-extracted family members to
 * land on different entity_ids. (This consolidates an original four-way fork,
 * written up in docs/INVESTIGATIONS/phase3-taxonomy-readout.md §6 — removed
 * in the 2026-09 docs cleanup, still in git history.)
 *
 * Rule (preserved from the historical A/B/C implementations — do not invent
 * new folding without updating the twin):
 *   1. Lowercase
 *   2. Fold Norwegian characters: æ→o, ø→o, å→a
 *   3. Non-alphanumerics → underscore
 *   4. Collapse runs of underscores
 *   5. Trim leading/trailing underscores
 *   6. Empty / nullish input → 'unknown'
 */
export function generateEntityId(name) {
  if (!name) return 'unknown';

  return name.toLowerCase()
    .replace(/[æø]/g, 'o')
    .replace(/å/g, 'a')
    .replace(/[^a-z0-9]/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_|_$/g, '');
}
